export default 'M17.06 17.06a1.5 1.5 0 0 1-2.12 0l-4.44-4.44V6a1.5 1.5 0 0 1 3 0v5.38l3.56 3.56a1.5 1.5 0 0 1 0 2.12M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24';